<template>
  <BreadCrumb PageTitle="Spacing" />
  <SpacingContent />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../template-components/Common/BreadCrumb.vue";
import SpacingContent from "../../template-components/Utilities/Spacing/SpacingContent.vue";

export default defineComponent({
  name: "SpacingPage",
  components: {
    BreadCrumb,
    SpacingContent,
  },
});
</script>